import PromptEngine from '@/components/PromptEngine';

const PromptEnginePage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      <PromptEngine />
    </div>
  );
};

export default PromptEnginePage;
